// src/app/spinner.service.ts
import { Injectable } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SpinnerService {
  private loadingSubject = new BehaviorSubject<boolean>(false);
  loading$ = this.loadingSubject.asObservable();
  constructor(
    private spinner: NgxSpinnerService,
  ) {
  }
  show() {
    this.spinner.show();
    this.loadingSubject.next(true);
  }

  hide() {
    this.loadingSubject.next(false);
    this.spinner.hide();
  }
}
